import { httpPost } from './axios'

export function login(username, password) {
  return httpPost('/login', { username, password });
}